import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import { Default } from '../../../../layouts';

import useDatasource from '../../../../hooks/useDatasource';
import {
  deleteStation,
  getStations,
} from '../../../../services/taxonomies/stations';

import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import Column from '../../../../helpers/columns';
import usePermissions from '../../../../hooks/usePermission';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const StationsList = () => {
  const { t } = useTranslation();

  const { pagination, content, handleChange, reload } =
    useDatasource(getStations);

  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.taxonomy.station.name'), {
        filter: true,
      }),
      Column.text('latitude', t('entity.taxonomy.station.latitude'), {
        filter: true,
      }),
      Column.text('longitude', t('entity.taxonomy.station.longitude'), {
        filter: true,
      }),
      Column.bool('deleted', t('entity.taxonomy.station.deleted._'), {
        width: 150,
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('entity.taxonomy.station.deleted.true'),
          t('entity.taxonomy.station.deleted.false'),
          t('table.filter.unknown'),
        ],
      }),
      Column.text('code', t('entity.taxonomy.station.code'), {
        filter: true,
      }),
      Column.actions(t('table.actions'), (record) => (
        <>
          {canView && (
            <ViewItemIcon path={`/admin/taxonomies/stations/${record.id}`} />
          )}
          {canEdit && (
            <EditItemIcon path={`/admin/taxonomies/stations/${record.id}`} />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t('entity.taxonomy.station._delete', record)}
              message={t('entity.taxonomy.station._deleted', record)}
              item={record}
              action={deleteStation}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );

  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.station._plural')}>
        <AddEntityButton
          entity={t('entity.taxonomy.station._singular')}
          path="/admin/taxonomies/stations/new"
        />
      </PageTitle>
      <Table
        columns={columns}
        rowKey="name"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </Default>
  );
};

export default StationsList;
